<!-- модалка смены СТАТУСА на 2 (ВЫИГРАЛ) -->
<template>
  <div class="t-lk-modal__content t-lk-win-lead-modal">
    <h2 class="t-lk-modal__title">Смена статуса</h2>

    <form class="t-lk-win-lead-modal__form">
      <div class="t-lk-win-lead-modal__row">
        <div class="t-lk-win-lead-modal__field">
          <lk-lead-date-cmp
            class="t-lk-win-lead-modal__date"
            :item="props.item"
            @change:date="handleChangeDate"
            UNSAFE_disabledInput
          />

          <input
            class="t-lk-win-lead-modal__input t-input"
            :class="{
              _error: !form.date.valid,
              _valid: form.date.valid,
            }"
            :value="formatedDate"
            placeholder="Дата сделки"
            readonly
          />
        </div>

        <div class="t-lk-win-lead-modal__field">
          <span class="t-lk-win-lead-modal__field-icon">₽</span>
          <input
            :value="form.amount.value"
            @input="handleChangeAmount"
            class="t-input t-lk-win-lead-modal__input"
            :class="{
              _error: !form.amount.valid,
              _valid: form.amount.valid,
            }"
            type="tel"
            placeholder="Сумма сделки"
          />
        </div>

        <div class="t-lk-win-lead-modal__field">
          <input
            :value="form.invoiceNumber.value"
            @focusin="handleChangeInvoiceNumber"
            @focusout="focusoutInvoiceNumber"
            @input="handleChangeInvoiceNumber"
            class="t-input t-lk-win-lead-modal__input"
            :class="{
              _error: !form.invoiceNumber.valid,
              _valid: form.invoiceNumber.valid,
            }"
            type="text"
            placeholder="Номер счета Axoft"
          />
        </div>
      </div>

      <p class="font-bold">
        Обратите внимание, баллы к репутации за выигранную сделку будут начислены только в случае заполнения поля с номером счета
      </p>

      <BaseSelect
        v-model="form.dealResult.value"
        @input="setFormValue(form.dealResult)"
        :label="form.dealResult.label"
        :options="form.dealResult.options"
        :required="form.dealResult.reqiured"
        :placeholder="form.dealResult.placeholder"
        :error="form.dealResult.error"
      ></BaseSelect>

      <RadioGroup
        v-model="form.relationshipDeveloped.value"
        @input="setFormValue(form.relationshipDeveloped)"
        :label="form.relationshipDeveloped.label"
        :options="form.relationshipDeveloped.options"
        :required="form.relationshipDeveloped.reqiured"
        :error="form.relationshipDeveloped.error"
      ></RadioGroup>

      <BaseTextarea
        v-model="form.dealComment.value"
        :label="form.dealComment.label"
        :options="form.dealComment.options"
      ></BaseTextarea>

      <div class="t-lk-win-lead-modal__controls">
        <button class="t-btn _green _lk" @click="handleSubmitClick">
          Изменить статус
        </button>

        <button class="t-btn _border-gray _lk" @click="handleRefuseClick">
          Отмена
        </button>
      </div>
    </form>

    <vue-recaptcha
      ref="recaptcha"
      size="invisible"
      :sitekey="$root.sitekeyRecaptcha"
      :load-recaptcha-script="true"
      @verify="onCapchaRegister"
      @expired="onCaptchaExpired"
      @error="errorCaptcha"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import lkLeadDate from '@components/lk/lk-date-lead/lk-date-lead.vue'
import FormField from '@modules/shared/ui/lk/form/FormField.vue'
import BaseSelect from '@modules/shared/ui/lk/form/BaseSelect.vue'
import RadioGroup from '@modules/shared/ui/lk/form/RadioGroup.vue'
import BaseTextarea from '@modules/shared/ui/lk/form/BaseTextarea.vue'
import VueRecaptcha from 'vue-recaptcha'
import { LEAD_DEAL_RESULT } from '@modules/leads/domain/data/deal.result.data'
import { LEAD_STATUS } from '@modules/leads/domain/data/lead.status.data'

export default {
  name: 'win-lead-modal',
  props: ['props'],
  components: {
    VueRecaptcha,
    'lk-lead-date-cmp': lkLeadDate,
    FormField,
    BaseSelect,
    RadioGroup,
    BaseTextarea,
  },
  data() {
    return {
      invoiceFieldPrefix: 'Ax',
      form: {
        amount: {
          value: undefined,
          valid: true,
        },
        date: {
          value: this.props.item.dealDate,
          valid: true,
        },
        invoiceNumber: {
          value: this.props.item.invoiceNumber,
          valid: true,
        },
        dealResult: {
          label: 'Как прошла ваша сделка с заказчиком?',
          placeholder: 'Внесите предложение по улучшению',
          value: this.props.item.dealResult,
          valid: true,
          error: '',
          reqiured: true,
          options: [
            { label: 'Сделка прошла только по переданному вендору', value: LEAD_DEAL_RESULT.VENDOR_ONLY },
            {
              label: 'Сделка прошла только по переданному вендору, но удалось сделать доппродажу',
              value: LEAD_DEAL_RESULT.VENDOR_WITH_UPSELL,
            },
            { label: 'Сделка прошла по другому вендору', value: LEAD_DEAL_RESULT.DIFFERENT_VENDOR },
          ],
        },
        relationshipDeveloped: {
          label: 'Удалось ли вам развить отношения с заказчиком и обсудить будущие проекты',
          value: this.props.item.relationshipDeveloped,
          valid: true,
          error: '',
          reqiured: true,
          options: [
            { label: 'Да', value: true },
            { label: 'Нет', value: false },
          ],
        },
        dealComment: {
          label: 'Что мы можем улучшить в сервисе, чтобы сделать его полезнее для Вас?',
          value: this.props.item.dealComment,
          valid: true,
          reqiured: false,
        },
      },
      recaptchaToken: null,
      vendorId: null,
      infoForm: {
        success: false,
        error: false,
      },
    }
  },
  computed: {
    ...mapState('lk/competencies', {
      legalInfo: state => state.legalInfo,
    }),
    isFormValid() {
      return Object.values(this.form).every(field => {
        if (this.hasFieldCheck(field)) return field.valid
        return true
      })
    },
    formatedDate() {
      if (!this.form.date.value) return ''
      const [dd, mm, yyyy] = this.form.date.value.split('-')
      return `${yyyy}.${mm}.${dd}`
    },
  },
  methods: {
    ...mapActions('modal', ['modalClose']),
    ...mapActions('lk/leads', {
      lk_changeStatus: 'changeStatus',
    }),
    handleChangeAmount(e) {
      this.form.amount.valid = true
      e.target.value = e.target.value.replace(/(^0+|\D+)/, '')

      if (!e.target.value) {
        this.form.amount.valid = false
      }

      this.form.amount.value = e.target.value
    },
    focusoutInvoiceNumber(e) {
      if (this.form.invoiceNumber.value === this.invoiceFieldPrefix) {
        e.target.value = ''
        this.form.invoiceNumber.value = null
      }
    },
    handleChangeInvoiceNumber(e) {
      const digits = e.target.value.replace(/\D/g, '').slice(0, 9)

      const masked = `${this.invoiceFieldPrefix}${digits}`

      e.target.value = masked

      this.form.invoiceNumber.value = masked
      this.form.invoiceNumber.valid = this.checkInvoiceNumber()
    },
    checkInvoiceNumber() {
      if (!this.form.invoiceNumber.value) return true
      const digits = this.form.invoiceNumber.value.replace(/\D/g, '').slice(0, 9)
      return (this.form.invoiceNumber.valid = digits.length === 9 || digits.length === 0)
    },
    handleChangeDate({ date }) {
      this.form.date.valid = true
      this.form.date.value = date
    },
    onCapchaRegister(recaptchaToken) {
      this.recaptchaToken = recaptchaToken
      if (this.isFormValid) this.sendForm()
    },
    handleSubmitClick(e) {
      e.preventDefault()
      e.stopPropagation()
      this.validate()

      if (!this.isFormValid) return

      const isProd = process.env.NODE_ENV === 'production'

      if (!isProd) {
        this.sendForm()
        return
      }

      this.$refs.recaptcha.execute()
    },
    hasFieldCheck(field) {
      return Object.hasOwn(field, 'valid')
    },
    handleRefuseClick(e) {
      e.preventDefault()
      e.stopPropagation()
      this.modalClose()
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    errorCaptcha() {
      console.log('errorCaptcha')
    },
    setFormValue(field) {
      field.valid = true
      if ('error' in field) field.error = null
    },
    validate() {
      this.form.date.valid = !!this.form.date.value
      this.form.amount.valid = !!this.form.amount.value
      this.form.invoiceNumber.valid = this.checkInvoiceNumber()

      if (!!this.form.dealResult.value) {
        this.form.dealResult.valid = true
        this.form.dealResult.error = null
      } else {
        this.form.dealResult.valid = false
        this.form.dealResult.error = 'Обязательное поле'
      }

      if (this.form.relationshipDeveloped.value !== undefined) {
        this.form.relationshipDeveloped.valid = true
        this.form.relationshipDeveloped.error = null
      } else {
        this.form.relationshipDeveloped.valid = false
        this.form.relationshipDeveloped.error = 'Обязательное поле'
      }
    },
    async sendForm() {
      await this.lk_changeStatus({
        id: this.props.item.id,
        status: LEAD_STATUS.WON,
        date: this.form.date.value,
        amount: this.form.amount.value,
        invoiceNumber: this.form.invoiceNumber.value ?? '',
        dealResult: this.form.dealResult.value,
        relationshipDeveloped: this.form.relationshipDeveloped.value,
        dealComment: this.form.dealComment.value,
      })

      await this.props.winLeadHandler?.()
    },
  },
}
</script>

<style lang="sass">
.t-lk-win-lead-modal
  max-width: 500px

  &__form
    margin-block-start: 36px
    display: flex
    flex-direction: column
    gap: 24px

  &__row
    display: flex
    gap: 24px

  &__field
    position: relative
    display: flex
    flex-direction: row
    gap: 16px

  &__input.t-input
    padding-inline-start: 36px

  &__date.t-lk-date-input__container
    position: absolute
    inset: 0

    & .t-lk-date-input
      padding-inline-start: 8px
      height: 100%
      width: 100%
      display: flex
      align-items: center

  &__field-icon
    font-size: 24px
    font-weight: 700
    position: absolute
    inset-block: 0
    inset-inline-start: 16px
    display: flex
    align-items: center
    color: #00b0bd

  &__controls
    margin-block-start: 12px
    display: flex
    flex-direction: row
    gap: 24px
    justify-content: flex-end
</style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/win-lead-modal.vue